import type { UpdateableLineItem } from '@paintscout/util/builder'
import { updateLineItem, getLineItem } from '@paintscout/util/builder'
import type { OptionsDocument, QuoteDocument } from 'paintscout'

export const calculateUpdateableLineItem = ({
  item,
  options,
  quote
}: {
  item: UpdateableLineItem
  options: OptionsDocument
  quote: QuoteDocument
}): UpdateableLineItem => {
  const updatedQuote = updateLineItem({ quote, options, item })
  return getLineItem({ quote: updatedQuote, key: item.key })
}
